import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toAutomationId'
})
export class ToAutomationIdPipe implements PipeTransform {
    transform(input: string, prop?: { prefix?: string; suffix?: string }): string {
        if (prop?.prefix) {
            input = prop?.prefix + input;
        }
        if (prop?.suffix) {
            input += prop?.suffix;
        }

        return input.replace(/\s/g, ''); // replace all white space
    }
}
